import * as React from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from 'components/controls/widget';
import CssBaseline from 'components/controls/CssBaseline';
import { createTheme, Theme, ThemeOptions } from 'components/controls/styles';
import App from "./App";


const themeOptions: ThemeOptions = {
    palette: {
        primary: { main: '#337ab7' },
        secondary: { main: '#f50057' },
        info: { main: '#f0f8ff' },
        success: { main: '#5cb85b', contrastText: '#fff' },
        error: { main: '#d9534f' },
        danger: { main: '#d9534f' },
        warning: { main: '#f0ad4e' }
    },
    typography: {
        useNextVariants: true,
        fontFamily: [
            'Arial',
            'Roboto',
            'Tahoma',
            'Helvetica',
            'sans-serif',

        ].join(','),
    },
    overrides: {
        MuiTableCell: {
            body: {
                fontSize: 'inherit'
            }
        },
        MuiTableRow: {
            root: {
                height: 36,
            }
        },
        MuiFormLabel: {
            root: {
                fontSize: '1rem',
                fontWeight: 'bold'
            }
        },
        MuiInputBase: {
            input: {
                //fontSize: '1.1rem',
                fontSize: '0.8rem',
            }
        },
        MuiInput: {
            formControl: {
                marginTop: 22
            }
        },
        MuiTypography: {
            subtitle2: {
                color: '#808080',
            }
        }
    }

}

class AppContainer extends React.PureComponent<{}> {

    constructor(props: {}) {
        super(props);

        this.theme = createTheme(themeOptions);
    }

    private theme: Theme;

    private setBg = () => {
        document.body.style.backgroundColor = "#E7E7E7";
    }

    render() {

        return <ThemeProvider theme={this.theme}>
            <CssBaseline />
            {this.setBg()}
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </ThemeProvider>;
    }
}

export default AppContainer;